import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import { useAuth } from '@/hooks/useAuth';
import { useReportAsync } from '@/stores/slice/authSlice';
import { useDispatch, useSelector } from 'react-redux';

const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = [] }) => {
  const { isAuthenticated, role, isLoading } = useAuth();
  const location = useLocation();
  const { subscription } = useSelector(state => state.auth)
   const dispatch = useDispatch()
  // Show loading while auth state is being determined
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wait for role to be available (should be available if authenticated)
  if (!role) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-600"></div>
      </div>
    );
  }

  // Check specific role requirement
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check if user has any of the allowed roles
  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Render protected content

  useEffect(() => {
    const callReportAsync = () => {
      if (isAuthenticated && navigator.onLine) {
         dispatch(useReportAsync());
      } else {
        console.log("No internet, skipping reportAsync");
      }
    };

    callReportAsync();
    window.addEventListener("online", callReportAsync);

    return () => {
      window.removeEventListener("online", callReportAsync);
    };
  }, [subscription, isAuthenticated, dispatch]);


  return (
    <>
      <Header />
      <main className="min-h-screen w-full bg-gray-100 md:mt-15 py-2">
        {children}
      </main>
    </>
  );
};

export default ProtectedRoute;